import { handleMessage, requestMessage } from '@business/messages';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { GraphResponse, GraphId, GraphOverlayQuery, CompactGraphResponse } from '@business/entities/graph';
import { GraphAPI } from '@business/api/graph';

export class GraphOverlayBloc extends BaseBloc {
  private readonly graphOverlayRepo = new Repository<CompactGraphResponse>({
    getItemId: item => item.id,
  });

  readonly overlayGraphs$ = this.graphOverlayRepo.items$;
  readonly overlayGraphs = this.graphOverlayRepo.items;
  readonly selectGraph = this.graphOverlayRepo.selectItem;

  onReset() {
    this.graphOverlayRepo.reset();
  }

  fetchGraphsOverlay = (id: GraphId) => {
    return GraphAPI.fetchGraphsOverlay(id).pipe(this.graphOverlayRepo.ops.reset(), handleMessage({ error: requestMessage('fetch_graph_error') }));
  };

  fetchOverlayGraph = (id: GraphId, data?: GraphOverlayQuery) => {
    return GraphAPI.fetchOverlayGraphDetails(id, data).pipe(
      this.graphOverlayRepo.ops.upsertOne(item => ({ item })),
      handleMessage({ error: requestMessage('fetch_graph_error') }),
    );
  };
}
